import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms"

import { OfferDetailComponent } from "./offer-detail/offer-detail.component";
import { OfferListingComponent } from "./offer-listing/offer-listing.component";
import { SharedModule } from 'src/app/shared/shared.module';
import { ModalModule } from 'ngx-bootstrap/modal';




const HOME_ROUTE = [
  { path: "", component: OfferDetailComponent },
  { path: "offer-list/:category", component: OfferListingComponent },
  { path: "offer-list/:category/:sub_category", component: OfferListingComponent },
  { path: "offer-details/:merchant_id", component: OfferDetailComponent },
  { path: "offer-details/:merchant_id/:type/:merchant_name", component: OfferDetailComponent }
];

@NgModule({
  declarations: [OfferListingComponent, OfferDetailComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(HOME_ROUTE),
    ModalModule.forRoot(),
    SharedModule
  ]
})
export class OffersModule { }
